module.exports = __webpack_public_path__ + "static/img/status_indication05.8f79d3d.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/air_2020/status_indication05.gif
// module id = SiCS
// module chunks = 1